import { Component, Input } from '@angular/core';
import { BillExplanationType } from '../models/extra-cost.model';
import { Router } from '@angular/router';
import { IOdbCoverDetailDivisionSummaryCategories } from '@dch/billing-business-logic';

@Component({
  selector: 'my-bill-odb-explanation-intro',
  templateUrl: './odb-bill-explanation-intro.component.html',
  standalone: false,
})
export class OdbBillExplanationIntroComponent {
  @Input() billExplanationType:
    | BillExplanationType
    | keyof IOdbCoverDetailDivisionSummaryCategories
    | 'thirdParty'
    | 'cpeReturnInfoPage'
    | 'reminderReactivationInfoPage';
  @Input() isPlacedAtRightSide = false;

  constructor(private router: Router) {}

  goToExplanationPage() {
    this.router.navigate(['/billing-explanation/' + this.billExplanationType]);
  }
}
